import 'mkt-ssr/components/UiEngineProvider/sailViewportSetup';
import React from 'react';

// eslint-disable-next-line no-restricted-imports
import {RootLayer} from '@sail/ui';
import {Provider as ThemeProvider} from '@sail/theme-classic';
import {helmTheme} from '@sail/helm';
import {globalStyles} from 'mkt-ssr/globalStyles';
import {markSailUsedForSSR} from 'mkt-ssr/lib/sail/ssrStylesFlag';

interface SailProviderProps {
  children: React.ReactNode;
}

export default function SailProvider({children}: SailProviderProps) {
  markSailUsedForSSR();

  return (
    <ThemeProvider>
      <RootLayer uses={[helmTheme, globalStyles]}>{children}</RootLayer>
    </ThemeProvider>
  );
}
